import React from 'react'
import { Card } from '../../../components'
import RenderPayment from './payment'

export default function FinanceMobileView({
    finances,
    onCreateInvoice,
    processingReceitaIds = [],
}) {
    return (
        <>
            {finances.map(finance => (
                <div key={finance.idReceita} className="mt-2">
                    <Card>
                        <div className="flex flex-col gap-1">
                            <div className="font-bold">{finance.service}</div>
                            <div>{finance.subservice}</div>
                            <div>
                                Referência:{' '}
                                <span className="font-bold">
                                    {finance.dtReference}
                                </span>
                            </div>
                            <div>
                                Vencimento:{' '}
                                <span className="font-bold">
                                    {finance.dtVencto}
                                </span>
                            </div>
                            <div>
                                Valor:{' '}
                                <span className="font-bold">
                                    R$ {finance.valueWithFare.replace('.', ',')}
                                </span>
                            </div>
                            <RenderPayment
                                item={finance}
                                onCreateInvoice={onCreateInvoice}
                                isMobile={true}
                                loading={processingReceitaIds.includes(
                                    finance.idReceita
                                )}
                            />
                        </div>
                    </Card>
                </div>
            ))}
        </>
    )
}
